"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEASUREMENT = exports.returnMeasurement = void 0;
var returnMeasurement = function (measure) {
    var lowerMeasure = measure.toLowerCase();
    switch (lowerMeasure) {
        case 'tsp':
            return MEASUREMENT.TSP;
        case 'tbsp':
            return MEASUREMENT.TBSP;
        case 'whole':
            return MEASUREMENT.WHOLE;
        case 'cup':
            return MEASUREMENT.CUP;
        case 'pack':
            return MEASUREMENT.PACK;
        case 'oz':
            return MEASUREMENT.OZ;
        case 'pinch':
            return MEASUREMENT.PINCH;
        case 'clove':
            return MEASUREMENT.CLOVE;
        case 'slice':
            return MEASUREMENT.SLICE;
        case 'package':
            return MEASUREMENT.PACKAGE;
        case 'lb':
            return MEASUREMENT.LB;
        case 'head':
            return MEASUREMENT.HEAD;
        case 'can':
            return MEASUREMENT.CAN;
        default:
            throw new Error('Measurement not found');
            break;
    }
};
exports.returnMeasurement = returnMeasurement;
var MEASUREMENT;
(function (MEASUREMENT) {
    MEASUREMENT["TSP"] = "tsp";
    MEASUREMENT["TBSP"] = "tbsp";
    MEASUREMENT["WHOLE"] = "whole";
    MEASUREMENT["CUP"] = "cup";
    MEASUREMENT["PACK"] = "pack";
    MEASUREMENT["OZ"] = "oz";
    MEASUREMENT["PINCH"] = "pinch";
    MEASUREMENT["CLOVE"] = "clove";
    MEASUREMENT["SLICE"] = "slice";
    MEASUREMENT["PACKAGE"] = "package";
    MEASUREMENT["LB"] = "lb";
    MEASUREMENT["HEAD"] = "head";
    MEASUREMENT["CAN"] = "can";
})(MEASUREMENT = exports.MEASUREMENT || (exports.MEASUREMENT = {}));
